export default "__VITE_ASSET__ea58e2d2__"